import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { HttpHelperService } from '../http-helper.service';

@Component({
  selector: 'app-ticket-details',
  templateUrl: './ticket-details.component.html',
  styleUrls: ['./ticket-details.component.css']
})
export class TicketDetailsComponent implements OnInit {

  public message: string = '';
  public sendNotification: boolean = false;
  public chats: Array<any> = [];

  constructor(public service: AmbitService,
    public httpHelper: HttpHelperService,
    public router: Router,
    public zone: NgZone,
    public route: ActivatedRoute) {
    if (this.service.adminUser.userAccess.tickets == 'None') {
      this.router.navigate(['/home']);
    }
    if (this.route.snapshot.params['id']) {
      service.ticketId = this.route.snapshot.params['id'];
    }

  }

  ngOnInit() {
    this.service.ticketId = this.route.snapshot.params['id'];
    if (this.route.snapshot.params['id']) {
      if (this.service.allTicketsList.length) {
        this.service.getTicketDetails();

      }
      this.getChats();
    }
  }

  getChats() {
    firebase.database().ref().child(`Quries/${this.service.ticketId}/Chat`).on("child_added", (snapshot) => {
      this.zone.run(() => {
        this.chats.push(snapshot.val());
        // this.scrollToBottom();
      });
    });
  }

  replyChat() {
    var self = this;
    var msgData: any = {
      text: self.message,
      timeStamp: Number(new Date()),
      uid: self.service.adminUser.uid,
    }
    var newKey = firebase.database().ref().child(`Quries/${self.service.ticketId}/Chat`).push().key;
    var updates = {};
    updates[`/Quries/${self.service.ticketId}/Chat/${newKey}`] = msgData;
    firebase.database().ref().update(updates).then(() => {
      self.sendTicketNotification(self.message);
      self.message = '';
    }).catch((error) => {
      console.log(error);
      self.message = '';
    });
  }

  changeTicketStatus() {
    var self = this;
    var updateData: any = {};
    updateData['Quries/' + self.service.ticketId + '/status'] = 'Resolved';
    firebase.database().ref().update(updateData).then(() => {
      self.service.ticketDetails.status = 'Resolved';
      self.service.pendigTicketsCount--;
      self.sendTicketNotification('');
      document.getElementById('closeStatusMd').click();
    }).catch((error) => {
      console.log(error);
    });
  }

  sendTicketNotification(message: any) {
    var self = this;
    var ticket = self.service.allTicketsList.find(ob => ob.ticketId === self.service.ticketId);
    var userData = self.service.allUsersList.find(ob => ob['email'] === self.service.ticketDetails.email);
    if (userData) {
      var notifyData: any = {}
      if (!message) {
        notifyData = { title: 'Ticket Status Is Updated', message: 'Your Orbit opend ticket: "' + ticket.name + '(' + ticket.ticketNo + ')" is resolved by Admin.', }
      } else {
        notifyData = {
          title: 'New Ticket Message Received',
          message: 'You have received a new message: "' + message + '", against your tickect: ' + ticket.name + '(' + ticket.ticketNo + ')'
        }
      }
      self.httpHelper.sendEmailNotifications([userData.email], notifyData);
      self.service.sendUserNotification(userData, notifyData)
    }
  }

}